import { PlayArrow, Pause, PlayCircle } from '@mui/icons-material';
import { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import '../../App.css'
import { useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button'
import { SelectGenericFromTable } from '../universal/Axios';
import { getStore } from '../../Store'
import { observer } from "mobx-react"
import { HandleDownload } from '../universal/IOHelper';
import { HandleAuthError } from '../universal/Alert';
import apiClient from '../../apiClient';
const store = getStore();


const InputAudioTable = observer(({ snsi_id }) => {
    let audioFilesData = store.inputAudioFiles

    useEffect(() => {
        SelectGenericFromTable("select * from audio_file where id in (" +
            "select signal_audio_file_id from signal_noise_separation_input snsi where snsi.id = '" + snsi_id + "'" +
            "union select noise_audio_file_id from signal_noise_separation_input snsi where snsi.id = '" + snsi_id + "'" +
            "union select combined_audio_file_id from signal_noise_separation_input snsi where snsi.id = '" + snsi_id + "');", store.updateInputAudioFiles)
    }, [snsi_id]);

    const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState(false);
    const [audio, setAudio] = useState(new Audio())

    const toggleAudioPlay = ({ source }) => {
        if (audio.src == source && currentlyPlayingAudio) {
            audio.pause();
            setCurrentlyPlayingAudio(false);
        }
        else {
            if (audio.src != source) {
                audio.src = source;
            }
            audio.play();
            setCurrentlyPlayingAudio(true)
        }
    }

    const getAudioButtonFromStatus = (file_name) => {
        if (audio.src.includes(file_name)) {
            return currentlyPlayingAudio ? <Pause /> : <PlayArrow />
        }
        return <PlayCircle />
    }

    const audioFileColumns = [
    {
        field: 'id',
        headerName: '',
        width: 130,
        renderCell: (params) => {
            return <>
                <Button
                    onClick={() => { toggleAudioPlay(params.row) }}
                >
                    {getAudioButtonFromStatus(params.row.source)}
                </Button>
                <Button
                    onClick={() => { HandleDownload(params.row.bucket, params.row.bucket_folder + "/", params.row.name) }}
                >
                    <DownloadIcon />
                </Button>
            </>
        },
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 400,
    },
    {
        field: 'bucket_folder',
        headerName: 'Folder',
        width: 520
    },
    {
        field: 'bucket',
        headerName: 'Bucket',
        width: 520
    },
    {
        field: 'source',
        headerName: 'Source',
        width: 820
    }
    ];

    const audioFilesRows = audioFilesData?.map((audioFile) =>
    ({   
        id: audioFile.id,
        name: audioFile.name,
        bucket_folder: audioFile.bucket_folder,
        bucket: audioFile.bucket,
        source: (audioFile.bucket_folder == null ? "https://storage.cloud.google.com/" + audioFile.bucket + "/" + audioFile.name
            : "https://storage.cloud.google.com/" + audioFile.bucket + "/" + audioFile.bucket_folder + "/" + audioFile.name)
    }))

    return (
        <Box sx={{ height: 300 }}>
            <DataGrid
                disableSelectionOnClick
                rows={audioFilesRows}
                columns={audioFileColumns}
                pagination={true}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                }}
            />
        </Box>
    )
});

export { InputAudioTable };
